import { getItemByCode, getTranslationResource, states as staticStates } from '@pba/static-data';

const transformState = (state: (typeof staticStates)[number]) => ({ code: state.code, translationKey: state.name.en });

export const states = staticStates.map((state) => transformState(state));

export const getTranslationStates = (language: keyof (typeof staticStates)[number]['name']) =>
  getTranslationResource(staticStates, language);

export const findStateByCode = (code?: string) => {
  const state = getItemByCode(staticStates, code ?? '');

  return state ? transformState(state) : undefined;
};
